module.exports = __webpack_public_path__ + "img/honer11.a3ee3052.jpg";